export default __webpack_public_path__ + "static/media/Monger-HUD-Artificial Horizon.533f9380.jpg";